import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const KeyIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Key",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M18.97 13.76c.47-1.29.63-2.68.46-4.05a8.74 8.74 0 0 0-9.71-7.65 8.735 8.735 0 0 0-7.71 8.63c0 4.43 3.28 8.17 7.67 8.74 1.37.17 2.75.02 4.05-.45l5.52 5.52c.16.16.38.25.61.25h2.26c.48 0 .87.39.87.87v2.26c0 .23.09.45.25.61l1.24 1.24c.16.16.38.25.61.25h4.01c.48 0 .87-.39.87-.87v-3.99c0-.23-.09-.45-.25-.61L18.96 13.75ZM7.25 9.04c-.97 0-1.75-.78-1.75-1.75s.78-1.75 1.75-1.75S9 6.32 9 7.29s-.78 1.75-1.75 1.75"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M19 21.29c-.63 0-1.14-.51-1.14-1.14v-3.43c0-.63.51-1.14 1.14-1.14h2.29v-2.29c0-.63.51-1.14 1.14-1.14h2.29V9.86c0-.63.51-1.14 1.14-1.14h2.29V4.15h-5.24l-6.52 6.52c-.45.45-1.17.45-1.62 0a1.14 1.14 0 0 1 0-1.62l6.86-6.86c.21-.21.5-.33.81-.33h6.86c.63 0 1.14.51 1.14 1.14v6.86c0 .63-.51 1.14-1.14 1.14h-2.29v2.29c0 .63-.51 1.14-1.14 1.14h-2.29v2.29c0 .63-.51 1.14-1.14 1.14h-2.29v2.29c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11 29.29c-5.04 0-9.14-4.1-9.14-9.14s4.1-9.14 9.14-9.14a1.14 1.14 0 1 1 0 2.28c-3.78 0-6.86 3.08-6.86 6.86s3.08 6.86 6.86 6.86 6.86-3.08 6.86-6.86a1.14 1.14 0 1 1 2.28 0c0 5.04-4.1 9.14-9.14 9.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11 23.57a1.14 1.14 0 1 1 0-2.28c.63 0 1.14-.51 1.14-1.14a1.14 1.14 0 1 1 2.28 0c0 1.89-1.54 3.43-3.43 3.43Z"
      })]
    })
  }));
};